import { NavLink, generatePath } from 'react-router-dom';
import Card from '../partial/card/card';
import Document from './document-item';
import { DocumentsTypes } from './types';

import { BankRoutes } from '../../routes';

import cn from './info.module.css';

const Documents = ({
  bankId,
  documents,
  isLoading,
  isEditable,
  accountPage,
  accountId,
  documentsErrorList,
  search,
}: DocumentsTypes) => {
  let link;

  if (accountPage) {
    link = generatePath(BankRoutes.BANK_AND_PSP_ACCOUNT_PAGE_ADD_DOCUMENTS, {
      accountId: accountId as string,
    });
  } else {
    link = generatePath(BankRoutes.BANK_AND_PSP_PAGE_ADD_DOCUMENTS, {
      bankId: bankId as string,
    });
  }

  return (
    <Card
      className={cn.documentsCard}
      isLoading={isLoading}
      title={
        <div className={cn.infoTitleWrapper}>
          <div className={cn.infoTitle}>Documents</div>
          {(bankId || accountId) && isEditable && (
            <NavLink
              to={`${generatePath(link)}${search || ''}`}
              className={cn.infoTitleLink}
            >
              <span className={cn.infoTitleLinkIcon}>+</span>
              <span className={cn.infoTitleLinkText}>Add</span>
            </NavLink>
          )}
        </div>
      }
    >
      <div>
        {documentsErrorList && (
          <div className={cn.loadingError}>
            <div className={cn.loadingErrorTitle}>Unable to load data</div>
            <div className={cn.loadingErrorText}>{documentsErrorList}</div>
          </div>
        )}
        {documents && !documentsErrorList && (
          <>
            {documents?.map((item) => (
              <Document
                key={item.id}
                document={item}
                bankId={bankId}
                accountId={accountId}
                accountPage={accountPage}
              />
            ))}
            {!documents?.length && (
              <div className={cn.emptyDocuments}>No documents yet</div>
            )}
          </>
        )}
      </div>
    </Card>
  );
};

export default Documents;
